import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import { AuditorCompetenceDetail } from '@/common';
import env from '@/env';

type Body = {
  name?: string;
  note?: string;
  validFrom?: string;
  validTo?: string;
  confirmDat?: string;
  compTypeId?: string;
};

export const createAuditorCompetence = async ({
  data,
  files,
}: {
  data: Body;
  files: File[];
}): Promise<AuditorCompetenceDetail> => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    // @ts-expect-error Expects an error on accessing data with string
    if (data[key]) {
      // @ts-expect-error Expects an error on accessing data with string
      formData.append(key, data[key]);
    }
  });

  files.forEach((file) => formData.append('files', file));

  const fetchResponse = await apiFetch(`${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-comps`, {
    method: 'POST',
    body: formData,
  });

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditorCompetenceDetail;
  return response;
};
